import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import BillPrint from '../sale/Bill';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress
} from '@mui/material';

const SaleCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [promoDiscountMessage, setPromoDiscountMessage] = useState('');
    const [promoDiscountOptions, setPromoDiscountOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Function to set promotional discount message with auto-clear timeout
    const setPromoDiscountMessageWithTimeout = (message) => {
        setPromoDiscountMessage(message);
        setTimeout(() => setPromoDiscountMessage(''), 1000);
    };
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    const [selectedGWPorPWP, setSelectedGWPorPWP] = useState(false); // Default to YES

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedDiscType, setSelectedDiscType] = useState("");
    const [dropdownDiscTypeOptions, setDropdownDiscTypeOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);



    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchDropdownDiscTypeOptions();
        fetchmaxbillno();
        promotionalSlab();
    }, []);

    const promotionalSlab = () => {
        fetchData('SaleApi', `/PromoSlab/${companyId}/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setPromoDiscountOptions(response.response_data || []);
                }
            })
            .catch((error) => {
                console.error('Error fetching promotional discount options:', error);
            });
    };

    const fetchmaxbillno = () => {
        fetchData('SaleApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillPrefix: data.BillPrefix,
                    AdditionalDiscountPercentage: 0,
                    PromoDiscountStartDate: data.PromoDiscountStartDate,
                    PromoDiscountEndDate: data.PromoDiscountEndDate,
                    PromoDiscountQuantity: data.PromoDiscountQuantity || 0,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });
    };

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownDiscTypeOptions = () => {
        fetchData('SaleApi', `/DiscType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownDiscTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    // Function to automatically select promotional discount percentage based on discounted item quantity
    const getAutoPromotionalDiscount = (discountedItemsCount) => {
        console.log('Debug - Discounted Items Count:', discountedItemsCount);
        console.log('Debug - Promo Discount Options:', promoDiscountOptions);

        if (!promoDiscountOptions || promoDiscountOptions.length === 0) {
            return 0;
        }

        // Sort options by MinimumQuantity in descending order to get the highest applicable discount
        const sortedOptions = [...promoDiscountOptions].sort((a, b) => b.MinimumQuantity - a.MinimumQuantity);
        console.log('Debug - Sorted Options:', sortedOptions);

        // Find the first option where discounted items count meets the minimum quantity requirement
        const applicableOption = sortedOptions.find(option => {
            const isApplicable = discountedItemsCount >= option.MinimumQuantity;
            console.log(`Debug - Checking option: ${option.DiscountPercentage}% (MinQty: ${option.MinimumQuantity}) - ${discountedItemsCount} >= ${option.MinimumQuantity} = ${isApplicable}`);
            return isApplicable;
        });

        console.log('Debug - Selected Option:', applicableOption);
        return applicableOption ? applicableOption.DiscountPercentage : 0;
    };

    // Validate if promotional discount should be applied based on quantity threshold
    const validatePromoDiscountEligibility = (invoiceDetails, promoDiscountQuantity) => {
        // Handle edge cases
        if (!invoiceDetails || !Array.isArray(invoiceDetails) || invoiceDetails.length === 0) {
            return false;
        }

        // Validate PromoDiscountQuantity is non-negative integer
        const validatedQuantity = parseInt(promoDiscountQuantity) || 0;
        if (validatedQuantity < 0) {
            return false;
        }

        // Count items with DiscountPercentage > 0
        const discountedItemsCount = invoiceDetails.filter(item => {
            const discountPercentage = parseFloat(item.DiscountPercentage);
            return !isNaN(discountPercentage) && discountPercentage > 0;
        }).length;

        // If PromoDiscountQuantity is not set or is 0, allow promotional discount
        if (validatedQuantity === 0) {
            return true;
        }

        return discountedItemsCount >= validatedQuantity;
    };

    // Extracted recalculation logic into a separate function for efficiency
    const recalculateInvoiceDetails = (currentFormData) => {
        const AdditionalDisc = parseFloat(currentFormData.AdditionalDiscountPercentage) || 0;

        const updatedItemData = invoicedeatils.map((item) => {
            const rate = parseFloat(item.Rate) || 0;
            const gstrate = parseFloat(item.GSTRate) || 0;
            const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
            const quantity = parseFloat(item.Quantity) || 0;

            // Calculate amounts
            const amount = (quantity * rate).toFixed(2);
            const discamt = ((rate * discountPercentage) / 100).toFixed(2);
            const Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
            const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
            const grate = (rate - totdiscount).toFixed(2);

            let promodiscountamt = 0;
            let RateAfterDiscount = grate;

            // Auto-calculate promotional discount percentage based on discounted items count
            // Only calculate if promotional discount is enabled
            let autoPromoPercentage = 0;
            if (isPromotionalDiscountEnabled()) {
                // For recalculation, count all items with discounts in the current invoice
                const discountedItemsCount = invoicedeatils.filter(invItem =>
                    parseFloat(invItem.DiscountPercentage) > 0
                ).length;

                autoPromoPercentage = getAutoPromotionalDiscount(discountedItemsCount);

                // Update form data with auto-calculated promotional discount percentage if different
                if (autoPromoPercentage !== parseFloat(currentFormData.PromotionalDiscountPercentage)) {
                    // Update immediately for recalculation context
                    currentFormData.PromotionalDiscountPercentage = autoPromoPercentage.toString();

                    // Also update the main form state
                    setTimeout(() => {
                        setFormData(prevData => ({
                            ...prevData,
                            PromotionalDiscountPercentage: autoPromoPercentage.toString()
                        }));
                    }, 0);
                }
            }

            let promodiscPercentage = autoPromoPercentage;

            // Check if item has discount percentage > 0 and promotional discount is enabled
            if (item.DiscountPercentage > 0 && isPromotionalDiscountEnabled()) {
                const isEligible = validatePromoDiscountEligibility(invoicedeatils, currentFormData.PromoDiscountQuantity);
                if (isEligible) {
                    promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                    // Set success message for promotional discount applied
                    if (promodiscPercentage > 0) {
                        setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                    }
                } else {
                    // Set warning message for promotional discount not applied due to quantity
                    const discountedItemsCount = invoicedeatils.filter(item =>
                        parseFloat(item.DiscountPercentage) > 0
                    ).length;
                    const requiredQuantity = parseInt(currentFormData.PromoDiscountQuantity) || 0;
                    if (requiredQuantity > 0) {
                        setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                    }
                }
            }
            let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

            const salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);

            // Calculate GST based on GST Number
            let cgst = 0, sgst = 0, igst = 0;

            if (!currentFormData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = currentFormData.GSTNumber.toString().substring(0, 2);
                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * gstrate) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            return {
                ...item,
                Amount: amount,
                DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

                RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                // PromotionalDiscountPercentage: parseFloat(promodiscPercentage).toFixed(2),
                PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",

                PromotionalDiscountAmount: parseFloat(promodiscountamt).toFixed(2),
                RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
            };
        });

        setInvoicedeatils(updatedItemData);

        // Calculate totals using reduce for efficiency
        const totals = updatedItemData.reduce((acc, item) => ({
            Quantity: acc.Quantity + parseFloat(item.Quantity),
            Amount: acc.Amount + parseFloat(item.Amount),
            DiscountAmount: acc.DiscountAmount + parseFloat(item.DiscountAmount),
            AddiDiscountAmount: acc.AddiDiscountAmount + parseFloat(item.AdditionalDiscountAmount),
            PromotionalDiscountAmount: acc.PromotionalDiscountAmount + parseFloat(item.PromotionalDiscountAmount),
            TaxableAmount: acc.TaxableAmount + parseFloat(item.TaxableAmount),
            CGSTAmount: acc.CGSTAmount + parseFloat(item.CGSTAmount),
            SGSTAmount: acc.SGSTAmount + parseFloat(item.SGSTAmount),
            IGSTAmount: acc.IGSTAmount + parseFloat(item.IGSTAmount),
            TotalAmount: acc.TotalAmount + parseFloat(item.TotalAmount),
        }), {
            Quantity: 0, Amount: 0, DiscountAmount: 0, AddiDiscountAmount: 0, PromotionalDiscountAmount: 0,
            TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0
        });

        // Get payment amounts
        const gvAmount = parseFloat(currentFormData.GVAmount) || 0;
        const CardAmount = parseFloat(currentFormData.CardAmount) || 0;
        const UPIAmount = parseFloat(currentFormData.UPIAmount) || 0;
        const totalDiscount = totals.DiscountAmount + totals.AddiDiscountAmount;
        const totalPromDiscount = totals.PromotionalDiscountAmount;
        // Call total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totalDiscount,
            totalPromDiscount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            gvAmount,
            CardAmount,
            UPIAmount
        );
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Fields that require full recalculation
        const recalculationFields = ['GVAmount', 'GSTNumber', 'CardAmount', 'UPIAmount', 'AdditionalDiscountPercentage', 'PromotionalDiscountPercentage'];

        if (recalculationFields.includes(name)) {
            // Update form data first
            const updatedFormData = {
                ...formData,
                [name]: name === 'GSTNumber' ? value :
                    name === 'AdditionalDiscountPercentage' ? parseFloat(value || 0).toFixed(2) :
                        parseFloat(value || 0).toFixed(2),
                ModifiedBy: userId,
            };

            setFormData(updatedFormData);

            // Perform recalculation with updated data
            recalculateInvoiceDetails(updatedFormData);
        } else {
            // Simple field update for other fields
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.ContactNumber) {
            setErrorMessage('Contact Number is required !');
            setIsLoading(false);
            return;
        }


        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        if (!selectedDiscType && formData.AdditionalDiscountPercentage > 0) {
            setErrorMessage('Disc Type is required !');
            setIsLoading(false);
            return;
        }

        if (selectedDiscType == "1" && !formData.SCMembershipNumber) {
            setErrorMessage('SC Membership Number is required !');
            setIsLoading(false);
            return;
        }

        if (selectedDiscType == "2" && !formData.VoucherNumber) {
            setErrorMessage('Voucher Number is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }


        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            GWPorPWPIncluded: selectedGWPorPWP,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        postData('SaleApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                // history.push('/SaleIndex');
                history.push('/Home');

                if (response.response === 'Sale Create Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }

            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${SaleId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            // Calculate promotional discount percentage based on updated item count
            let autoPromoPercentage = 0;
            if (isPromotionalDiscountEnabled()) {
                const discountedItemsCount = updatedRecords.filter(item =>
                    parseFloat(item.DiscountPercentage) > 0
                ).length;

                autoPromoPercentage = getAutoPromotionalDiscount(discountedItemsCount);

                // Update form data with the new promotional discount percentage
                if (autoPromoPercentage !== parseFloat(formData.PromotionalDiscountPercentage)) {
                    setFormData(prev => ({
                        ...prev,
                        PromotionalDiscountPercentage: autoPromoPercentage
                    }));
                }
            }

            // Recalculate promotional discounts on the updated data
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const recalculatedItems = updatedRecords.map((item) => {
                const rate = parseFloat(item.Rate) || 0;
                const gstrate = parseFloat(item.GSTRate) || 0;
                const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                const quantity = parseFloat(item.Quantity) || 0;

                // Calculate amounts
                const amount = (quantity * rate).toFixed(2);
                const discamt = ((rate * discountPercentage) / 100).toFixed(2);
                const Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                const grate = (rate - totdiscount).toFixed(2);

                let promodiscountamt = 0;
                let RateAfterDiscount = grate;
                let promodiscPercentage = autoPromoPercentage; // Use auto-calculated percentage

                // Check if item has discount percentage > 0 and quantity threshold is met
                if (item.DiscountPercentage > 0) {
                    const isEligible = validatePromoDiscountEligibility(updatedRecords, formData.PromoDiscountQuantity);
                    if (isEligible) {
                        promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                        // Set success message for promotional discount applied
                        if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                        }
                    } else {
                        // Set warning message for promotional discount not applied due to quantity
                        const discountedItemsCount = updatedRecords.filter(item =>
                            parseFloat(item.DiscountPercentage) > 0
                        ).length;
                        const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                        if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                        }
                    }
                }
                let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

                const salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);

                // Calculate GST based on GST Number
                let cgst = 0, sgst = 0, igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);
                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * gstrate) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

                    RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                    PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",
                    PromotionalDiscountAmount: parseFloat(promodiscountamt).toFixed(2),
                    RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            // Update the invoice details with recalculated promotional discounts
            setInvoicedeatils(recalculatedItems);

            // Calculate totals with the recalculated data
            const Quantity = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const totalPromoDiscount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.PromotionalDiscountAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, totalPromoDiscount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);
        }
    };

    //Items    
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            setFormData(prevData => ({
                ...prevData,
                BillDate: formattedDate,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        balanceStock: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            balanceStock: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (modalData.Quantity > modalData.balanceStock) {
            isValid = false;
            errors = "Quantity exceeds available stock.";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                balanceStock: 0,
            });

            setSelectedItem(0);
            //closeModal();

            // Recalculate promotional discounts on the updated data
            // First, calculate the new promotional discount percentage based on updated item count
            // Only calculate if promotional discount is enabled
            let autoPromoPercentage = 0;
            if (isPromotionalDiscountEnabled()) {
                const discountedItemsCount = updatedInvoicedetailsSorted.filter(invItem =>
                    parseFloat(invItem.DiscountPercentage) > 0
                ).length;

                autoPromoPercentage = getAutoPromotionalDiscount(discountedItemsCount);

                // Update form data with the new promotional discount percentage
                setFormData(prevData => ({
                    ...prevData,
                    PromotionalDiscountPercentage: autoPromoPercentage.toString()
                }));
            }

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const recalculatedItems = updatedInvoicedetailsSorted.map((item) => {
                const rate = parseFloat(item.Rate) || 0;
                const gstrate = parseFloat(item.GSTRate) || 0;
                const discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                const quantity = parseFloat(item.Quantity) || 0;

                // Calculate amounts
                const amount = (quantity * rate).toFixed(2);
                const discamt = ((rate * discountPercentage) / 100).toFixed(2);
                const Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2);
                const totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                const grate = (rate - totdiscount).toFixed(2);

                let promodiscountamt = 0;
                let RateAfterDiscount = grate;
                let promodiscPercentage = autoPromoPercentage; // Use the auto-calculated percentage

                // Check if item has discount percentage > 0 and quantity threshold is met
                if (item.DiscountPercentage > 0) {
                    const isEligible = validatePromoDiscountEligibility(updatedInvoicedetailsSorted, formData.PromoDiscountQuantity);
                    if (isEligible) {
                        promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                        // Set success message for promotional discount applied
                        if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                        }
                    } else {
                        // Set warning message for promotional discount not applied due to quantity
                        const discountedItemsCount = updatedInvoicedetailsSorted.filter(item =>
                            parseFloat(item.DiscountPercentage) > 0
                        ).length;
                        const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                        if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                        }
                    }
                }
                let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

                const salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);

                // Calculate GST based on GST Number
                let cgst = 0, sgst = 0, igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);
                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * gstrate) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

                    RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                    PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",
                    PromotionalDiscountAmount: parseFloat(promodiscountamt).toFixed(2),
                    RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            // Update the invoice details with recalculated promotional discounts
            setInvoicedeatils(recalculatedItems);

            // Calculate totals with the recalculated data
            const Quantity = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const AddiDiscountAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.AdditionalDiscountAmount), 0);
            const TaxableAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const totalPromoDiscount = recalculatedItems.reduce((sum, item) => sum + parseFloat(item.PromotionalDiscountAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            const totdisc = parseFloat(DiscountAmount) + parseFloat(AddiDiscountAmount);
            totalCalculation(Quantity, Amount, totdisc, totalPromoDiscount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

            setIsModalOpen(!isModalOpen);

        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, totalPromDiscount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            PromotionalDiscountAmount: totalPromDiscount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';

        const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
            let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);

            // Promotional discount calculation with quantity validation
            let promodiscountamt = 0;
            let RateAfterDiscount = grate;
            let promodiscPercentage = parseFloat(formData.PromotionalDiscountPercentage) || 0;

            // Check if item has discount percentage > 0 and quantity threshold is met
            if (discountPercentage > 0) {
                const isEligible = validatePromoDiscountEligibility(invoicedeatils, formData.PromoDiscountQuantity);
                if (isEligible) {
                    promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                    // Set success message for promotional discount applied
                    if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                        setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                    }
                } else {
                    // Set warning message for promotional discount not applied due to quantity
                    const discountedItemsCount = invoicedeatils.filter(item =>
                        parseFloat(item.DiscountPercentage) > 0
                    ).length;
                    const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                    if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                        setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                    }
                }
            }
            let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

            let salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
                PromotionalDiscountPercentage: Number(selectedItemDetail.DiscountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",
                PromotionalDiscountAmount: parseFloat(promodiscountamt * quantity).toFixed(2),
                RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                GSTRate: '0',
                HSNCode: '',
                DiscountPercentage: '',
                AdditionalDiscountPercentage: 0,
                balanceStock: 0,
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        const intValue = parseInt(value, 10);

        if (intValue > modalData.balanceStock) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }

        setModalData({
            ...modalData,
            [name]: value,
        });

        const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
        let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);

        // Promotional discount calculation with quantity validation
        let promodiscountamt = 0;
        let RateAfterDiscount = grate;
        let promodiscPercentage = parseFloat(formData.PromotionalDiscountPercentage) || 0;

        // Check if item has discount percentage > 0 and quantity threshold is met
        if (discountPercentage > 0) {
            const isEligible = validatePromoDiscountEligibility(invoicedeatils, formData.PromoDiscountQuantity);
            if (isEligible) {
                promodiscountamt = ((grate * promodiscPercentage) / 100).toFixed(2);
                // Set success message for promotional discount applied
                if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                    setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                }
            } else {
                // Set warning message for promotional discount not applied due to quantity
                const discountedItemsCount = invoicedeatils.filter(item =>
                    parseFloat(item.DiscountPercentage) > 0
                ).length;
                const requiredQuantity = parseInt(formData.PromoDiscountQuantity) || 0;
                if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                    setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                }
            }
        }
        let RateAfterPromotionalDiscount = (RateAfterDiscount - promodiscountamt).toFixed(2);

        let salerate = (RateAfterPromotionalDiscount / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
            AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
            AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),

            RateAfterDiscount: parseFloat(RateAfterDiscount).toFixed(2),
            //PromotionalDiscountPercentage: parseFloat(promodiscPercentage).toFixed(2),
            PromotionalDiscountPercentage: Number(discountPercentage) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",

            PromotionalDiscountAmount: parseFloat(promodiscountamt * quantity).toFixed(2),
            RateAfterPromotionalDiscount: parseFloat(RateAfterPromotionalDiscount).toFixed(2),

            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    // Helper function to check if promotional discount should be enabled
    const isPromotionalDiscountEnabled = () => {
        const { BillDate, PromoDiscountStartDate, PromoDiscountEndDate } = formData;

        // If any of the required dates are missing, disable promotional discount
        if (!BillDate || !PromoDiscountStartDate || !PromoDiscountEndDate) {
            return false;
        }

        const billDate = new Date(BillDate);
        const startDate = new Date(PromoDiscountStartDate);
        const endDate = new Date(PromoDiscountEndDate);

        // Check if bill date is between start and end dates (inclusive)
        return billDate >= startDate && billDate <= endDate;
    };

    const handleEdit = (index, field, value) => {
        setInvoicedeatils((prev = []) => {
            // ===== UPDATE ITEM VALUE =====
            const updatedItems = prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );

            const gvamt = parseFloat(formData?.GVAmount) || 0;

            // ===== RECALCULATE EACH ITEM =====
            const updatedItemData = updatedItems.map((item) => {
                const rate = parseFloat(item?.Rate) || 0;
                const gstrate = parseFloat(item?.GSTRate) || 0;
                const discountPct = parseFloat(item?.DiscountPercentage) || 0;
                const additionalPct = parseFloat(item?.AdditionalDiscountPercentage) || 0;
                const quantity = parseFloat(item?.Quantity) || 0;

                // Base amount
                const amount = quantity * rate;

                // Discounts (per unit)
                const discAmtPerUnit = (rate * discountPct) / 100;
                const addlDiscAmtPerUnit = (rate * additionalPct) / 100;
                const totalDiscPerUnit = discAmtPerUnit + addlDiscAmtPerUnit;

                // Net & sale rate
                const netRate = rate - totalDiscPerUnit;

                // Promotional discount calculation with quantity validation
                let promodiscountamt = 0;
                let RateAfterDiscount = netRate;
                let promodiscPercentage = parseFloat(formData?.PromotionalDiscountPercentage) || 0;

                // Check if item has discount percentage > 0 and quantity threshold is met
                if (discountPct > 0) {
                    const isEligible = validatePromoDiscountEligibility(updatedItems, formData?.PromoDiscountQuantity);
                    if (isEligible) {
                        promodiscountamt = (netRate * promodiscPercentage) / 100;
                        // Set success message for promotional discount applied
                        if (promodiscPercentage > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount of ${promodiscPercentage}% applied successfully!`);
                        }
                    } else {
                        // Set warning message for promotional discount not applied due to quantity
                        const discountedItemsCount = updatedItems.filter(item =>
                            parseFloat(item.DiscountPercentage) > 0
                        ).length;
                        const requiredQuantity = parseInt(formData?.PromoDiscountQuantity) || 0;
                        if (requiredQuantity > 0 && isPromotionalDiscountEnabled()) {
                            setPromoDiscountMessage(`Promotional discount not applied: Need ${requiredQuantity} discounted items, but only ${discountedItemsCount} items have discounts.`);
                        }
                    }
                }
                let RateAfterPromotionalDiscount = RateAfterDiscount - promodiscountamt;

                const saleRate = RateAfterPromotionalDiscount / (1 + gstrate / 100);

                // Taxable & GST
                const taxableAmount = quantity * saleRate;
                let cgst = 0, sgst = 0, igst = 0;

                const gstNumber = formData?.GSTNumber?.toString() || "";
                if (!gstNumber) {
                    // No GST number → CGST + SGST
                    cgst = (taxableAmount * (gstrate / 2)) / 100;
                    sgst = (taxableAmount * (gstrate / 2)) / 100;
                } else {
                    const gstPrefix = gstNumber.substring(0, 2);
                    if (gstPrefix !== branchstate) {
                        igst = (taxableAmount * gstrate) / 100; // Inter-state
                    } else {
                        cgst = (taxableAmount * (gstrate / 2)) / 100;
                        sgst = (taxableAmount * (gstrate / 2)) / 100;
                    }
                }

                const totalAmount = Math.round(taxableAmount + cgst + sgst + igst);

                return {
                    ...item,
                    Amount: amount.toFixed(2),
                    DiscountAmount: (discAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountAmount: (addlDiscAmtPerUnit * quantity).toFixed(2),
                    AdditionalDiscountPercentage: additionalPct.toFixed(2),

                    RateAfterDiscount: RateAfterDiscount.toFixed(2),
                    //PromotionalDiscountPercentage: promodiscPercentage.toFixed(2),
                    PromotionalDiscountPercentage: Number(discountPct) > 0 ? Number(promodiscPercentage).toFixed(2) : "0.00",

                    PromotionalDiscountAmount: (promodiscountamt * quantity).toFixed(2),
                    RateAfterPromotionalDiscount: RateAfterPromotionalDiscount.toFixed(2),

                    TaxableAmount: taxableAmount.toFixed(2),
                    CGSTAmount: cgst.toFixed(2),
                    SGSTAmount: sgst.toFixed(2),
                    IGSTAmount: igst.toFixed(2),
                    TotalAmount: totalAmount.toFixed(2),
                };
            });

            // ===== GRAND TOTALS =====
            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseFloat(item?.Quantity) || 0;
                    acc.Amount += parseFloat(item?.Amount) || 0;
                    acc.DiscountAmount += parseFloat(item?.DiscountAmount) || 0;
                    acc.AddiDiscountAmount += parseFloat(item?.AdditionalDiscountAmount) || 0;
                    acc.PromotionalDiscountAmount += parseFloat(item?.PromotionalDiscountAmount) || 0;
                    acc.TaxableAmount += parseFloat(item?.TaxableAmount) || 0;
                    acc.CGSTAmount += parseFloat(item?.CGSTAmount) || 0;
                    acc.SGSTAmount += parseFloat(item?.SGSTAmount) || 0;
                    acc.IGSTAmount += parseFloat(item?.IGSTAmount) || 0;
                    acc.TotalAmount += parseFloat(item?.TotalAmount) || 0;
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    AddiDiscountAmount: 0,
                    PromotionalDiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            // ===== ADD PAYMENT DATA =====
            const CardAmount = parseFloat(formData?.CardAmount) || 0;
            const UPIAmount = parseFloat(formData?.UPIAmount) || 0;
            const totalDiscount = totals.DiscountAmount + totals.AddiDiscountAmount;

            // ===== FINAL CALL =====
            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totalDiscount,
                totals.PromotionalDiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                gvamt,
                CardAmount,
                UPIAmount
            );

            // ✅ Return updated items as new state
            return updatedItemData;
        });
    };


    return (

        <Fragment>

            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Sale - Create
                    </h6>

                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to="/Home"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}
                {/* {promoDiscountMessage && (
                    <p className={promoDiscountMessage.includes('applied successfully') ? "text-green-500" : "text-yellow-600"}>
                        {promoDiscountMessage}
                    </p>
                )} */}

                <div className="w-full mb-4 flex" style={{ marginTop: '-1.50%' }}>
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '550px', overflowY: 'auto', maxWidth: '100%' }}>
                        <div className="w-full mb-2 flex" style={{ marginTop: '-1.25%' }}>

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Customer Name
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.CustomerName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Customer Name"
                                    name='CustomerName'
                                    maxLength={100}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formatDateForInput(formData.BillDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='BillDate'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.BillNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Bill Number"
                                    name='BillNumber'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Qty
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Total Quantity"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Addt'l. DISC Type
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedDiscType ? 'fade-in' : 'fade-in'}`}
                                    value={selectedDiscType}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedDiscType(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            DiscTypeId: selectedValue,
                                        }));
                                    }}
                                >
                                    <option value="">Disc Type</option>
                                    {dropdownDiscTypeOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Addt'l. Disc %
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.AdditionalDiscountPercentage}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Disc %"
                                    style={{ textAlign: 'right' }}
                                    name='AdditionalDiscountPercentage'
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                            e.target.value = value.slice(0, -1);
                                        }
                                    }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-4 flex" style={{ marginTop: '-0.50%' }}>
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.CustomerAddress}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Address"
                                    name='CustomerAddress'
                                    maxLength={200}
                                />
                            </div>

                            <div className="w-2/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GST Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.GSTNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GST Number"
                                    name='GSTNumber'
                                    maxLength={15}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Phone No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  h-8"
                                    value={formData.ContactNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Phone Number"
                                    name='ContactNumber'
                                    maxLength={15}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sales Man
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                    value={selectedSalesMan}
                                    // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedSalesMan(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            SalesManId: selectedValue,
                                        }));
                                    }}
                                >
                                    <option value="">Sales Man</option>
                                    {dropdownSalesManOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select">
                                    GWP/PWP
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="yes-no-select"
                                    className={`custom-select ${selectedGWPorPWP ? 'fade-in' : 'fade-in'}`}
                                    value={selectedGWPorPWP}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value === "true"; // Convert string "true"/"false" to boolean
                                        setSelectedGWPorPWP(selectedValue); // Update state with the selected value
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            GWPorPWPIncluded: selectedValue, // Update form data with the selected value
                                        }));
                                    }}
                                >
                                    <option value={true}>YES</option>
                                    <option value={false}>NO</option>
                                </select>
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                        </div>


                        <div className="w-full flex items-center gap-x-2 p-2" style={{ borderRadius: '10px', marginTop: '-1.70%', height: '90px' }}>
                            <div className="w-full mb-4 flex">
                                <div className="w-2/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                        Item Name
                                    </label>
                                    <Select
                                        value={selectedItems}
                                        onChange={handleItemSelect}
                                        options={itemsOptions}
                                        placeholder="Items"
                                        isSearchable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: "35px",   // same as your inputs
                                                height: "35px",
                                                fontSize: "14px",
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: "35px",      // keeps text aligned properly
                                                padding: "0 6px",
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: "35px",      // makes dropdown arrow align
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 1301,
                                                fontSize: "14px",
                                            }),
                                        }}
                                    />

                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                        Quantity
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                        type="text"
                                        name="Quantity"
                                        placeholder="Quantity"
                                        value={modalData.Quantity}
                                        onChange={handleModalInputChange}
                                        onInput={(e) => {
                                            const value = e.target.value;
                                            if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                                e.target.value = value.slice(0, -1);
                                            }
                                        }}
                                    />
                                    {!isValid && (
                                        <p className="text-red-500 text-xs italic">
                                            Quantity exceeds available stock.
                                        </p>
                                    )}
                                </div>

                                <div className="w-1/5 flex items-end">
                                    <Button className="bg-blue-500 text-white px-3 py-1 rounded flex items-center gap-1" onClick={saveModalData}>
                                        <AddIcon style={{ color: 'darkmagenta', fontWeight: 'bolder' }} />
                                        <span style={{ color: 'darkmagenta', fontWeight: 'bolder' }}>Add Item</span>
                                    </Button>
                                </div>

                                <div className="w-1/6 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Promo. Disc %
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-10 ${!isPromotionalDiscountEnabled() ? 'bg-gray-200 cursor-not-allowed' : ''
                                            }`}
                                        value={formData.PromotionalDiscountPercentage}
                                        onChange={handleChange}
                                        name='PromotionalDiscountPercentage'
                                        disabled
                                        style={{ textAlign: 'right', lineHeight: '1.2' }}
                                    >
                                        <option value="0">0%</option>
                                        {promoDiscountOptions.map((option, index) => (
                                            <option key={index} value={option.DiscountPercentage}>
                                                {option.DiscountPercentage}% (Min Qty: {option.MinimumQuantity})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Promo. Disc Amount
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-10"
                                        value={formData.PromotionalDiscountAmount}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Disc %"
                                        style={{ textAlign: 'right' }}
                                        name='PromotionalDiscountAmount'
                                        readOnly
                                    />
                                </div>
                            </div>

                        </div>


                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.50%' }}>
                            <div
                                className="w-full mb-2 flex"
                                style={{
                                    maxHeight: "450px",
                                    overflowY: "auto",
                                    marginTop: "3px",
                                }}
                            >
                                <TableContainer component={Paper}>
                                    <Table stickyHeader>
                                        <TableHead stickyHeader>
                                            <TableRow>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Sl.No
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}>
                                                    Item Name
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}>
                                                    Quantity
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    MRP
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Disc %
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Addt'l Disc %
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Promo. %
                                                </TableCell>

                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Promo. Amt
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                    }}
                                                >
                                                    Amount
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        fontSize: "11px",
                                                        backgroundColor: "#435560",
                                                        padding: "1px",
                                                        color: "whitesmoke",
                                                        textTransform: "uppercase",
                                                        fontWeight: "bolder",
                                                        textAlign: "center",
                                                    }}
                                                >

                                                </TableCell>

                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {invoicedeatils.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={7} align="center" style={{ fontSize: "12px", padding: "10px" }}>
                                                        No containers added yet.
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                invoicedeatils.map((item, index) => (
                                                    <TableRow key={index} hover>
                                                        {/* Sl.No (not editable) */}
                                                        <TableCell
                                                            style={{
                                                                fontSize: "13px",
                                                                padding: "6px",
                                                                textAlign: "center",
                                                                borderRight: "1px solid #D6DAC8",
                                                                width: "50px",
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", width: '45%' }}>
                                                            {item.ItemName}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '7%' }}>
                                                            <input
                                                                type="text"
                                                                value={item.Quantity}
                                                                onChange={(e) =>
                                                                    handleEdit(index, "Quantity", e.target.value)
                                                                }
                                                                onInput={(e) => {
                                                                    const value = e.target.value;
                                                                    if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                                                        e.target.value = value.slice(0, -1);
                                                                    }
                                                                }}
                                                                style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right' }}
                                                            />
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '10%' }}>
                                                            {item.Rate}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '10%' }}>
                                                            {item.DiscountPercentage}
                                                        </TableCell>

                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", width: '10%' }}>
                                                            <input
                                                                type="text"
                                                                onChange={(e) =>
                                                                    handleEdit(index, "AdditionalDiscountPercentage", e.target.value)
                                                                }
                                                                value={item.AdditionalDiscountPercentage}
                                                                onInput={(e) => {
                                                                    const value = e.target.value;
                                                                    if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                                                        e.target.value = value.slice(0, -1);
                                                                    }
                                                                }}
                                                                style={{ width: "100%", fontSize: "13px", fontWeight: 'bold', padding: "4px", textAlign: 'right' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '7%' }}>
                                                            {item.PromotionalDiscountPercentage}
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '10%' }}>
                                                            {item.PromotionalDiscountAmount}
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: "13px", fontWeight: 'bold', padding: "6px", borderRight: "1px solid #D6DAC8", textAlign: 'right', width: '15%' }}>
                                                            {item.TotalAmount}
                                                        </TableCell>
                                                        <TableCell
                                                            style={{
                                                                fontSize: "13px",
                                                                padding: "6px",
                                                                textAlign: "right",
                                                                borderRight: "1px solid #D6DAC8",
                                                                width: "50px",
                                                            }}
                                                        >
                                                            <IconButton style={{ padding: '2px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ color: 'red' }} />
                                                            </IconButton>

                                                        </TableCell>


                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </div>
                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Remarks"
                                    name='Remarks'
                                    maxLength={200}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Amount"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='TotalAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.DiscountAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Discount"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='DiscountAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash Disc
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CashDiscount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Cash Discount"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='CashDiscount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GV Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GVAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GV Amount"
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    name='GVAmount'
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                            e.target.value = value.slice(0, -1);
                                        }
                                    }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Net Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TaxableAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Net Amount"
                                    name='TaxableAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CGST"
                                    name='CGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.SGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="SGST"
                                    name='SGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.IGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="IGST"
                                    name='IGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.RoundOff}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Round Off"
                                    name='RoundOff'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GrandTotal}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Grand Total"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8 ${formData.CashAmount < 0 ? 'text-red-500' : ''}`}
                                    value={formData.CashAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Cash"
                                    name='CashAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Card
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CardAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Card"
                                    name='CardAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                            e.target.value = value.slice(0, -1);
                                        }
                                    }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    UPI/ RTGS/ OTHER
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.UPIAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="UPI"
                                    name='UPIAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        if (!/^\d*\.?\d{0,2}$/.test(value) && value !== '') {
                                            e.target.value = value.slice(0, -1);
                                        }
                                    }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            {formData.CardAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedCardType ? 'fade-in' : 'fade-in'}`}
                                        value={selectedCardType}
                                        // onChange={(e) => setSelectedCardType(e.target.value)}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedCardType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                CardType: selectedValue,
                                            }));
                                        }}
                                    >
                                        <option value="">Select CardType</option>
                                        {dropdownCardTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}

                            {formData.CardAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CardNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Card Number"
                                        name='CardNumber'
                                        maxLength={20}
                                    />
                                </div>
                            )}

                            {formData.UPIAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        UPI Number/ RTGS/ OTHERS
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.UPINumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="UPI/ RTGS/ OTHER Number"
                                        name='UPINumber'
                                        maxLength={20}
                                    />
                                </div>
                            )}

                            {formData.DiscTypeId == 1 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        SC MembershipNumber
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.SCMembershipNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="SC Membership Number"
                                        name='SCMembershipNumber'
                                        maxLength={100}
                                    />
                                </div>
                            )}

                            {formData.DiscTypeId == 2 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Voucher Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.VoucherNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Voucher Number"
                                        name='VoucherNumber'
                                        maxLength={100}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="flex justify-left flex-end mr-4">
                            <label className="flex justify-end cursor-pointer" style={{ fontWeight: 'bold', color: 'darkblue' }}>
                                <input
                                    type="checkbox"
                                    className="mr-2 w-4 h-4 accent-blue-500 border-gray-300 rounded focus:ring focus:ring-blue-300"
                                    checked={formData.IsStockTransfer}
                                    name='IsStockTransfer'
                                    onChange={handleChange}
                                    style={{ transform: 'scale(1.2)' }}  // To scale up the checkbox size
                                />
                                INTER CITY STOCK TRANSFER
                            </label>
                        </div>

                    </div>



                </div>


            </div >
        </Fragment >

    );
};

export default SaleCreate;